import { keycloakConfig } from './config';

export function setCookiesFromServer(token: string) {
  return new Promise<boolean>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${keycloakConfig.url}realms/${keycloakConfig.realm}/set-cookie-by-token`, true);
    xhr.setRequestHeader('authorization', 'Bearer ' + token);
    xhr.withCredentials = true;
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        const status = xhr.status;
        if (status === 0 || (status >= 200 && status < 400)) {
          // The request has been completed successfully
          resolve(true)
        } else {
          // Oh no! There has been an error with the request!
          reject(xhr.responseText)
        }
      }
    };
    xhr.send();
  })
}
